import styled from 'styled-components';
import media from '../../../../../constants/media';
import { A } from '../../../../base/typography';

export const Wrapper = styled.div``;

export const SectionHeading = styled.h3`
	font-family: ${({ theme }) => theme.fonts.SharpSlab};
	font-weight: 700;
	font-size: 2.8rem;
	color: ${({ theme }) => theme.colors.black};
	margin: 5rem 0 1.5rem;
`;

export const AddContentsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0 0 2.5rem;
	button {
		width: 100%;
	}
`;

export const RemoveContentLine = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	padding: 1.5rem;
	color: ${({ theme }) => theme.colors.primary};
	cursor: pointer;

	&:hover {
		color: ${({ theme }) => theme.colors.primaryDark};
	}
`;

export const DangerousContentsWrapper = styled.div`
	//margin-top: 0rem;
	margin-bottom: 5rem;
	border: 4px solid ${({ theme }) => theme.colorsV2.mainPink}4d; /* mainPink @ ~30% */
	border-radius: 8px;
	padding: 2rem;
`;

export const DangerousContentsListLink = styled(A)`
	display: inline-block;
	margin-top: 1rem;
`;

export const ShippableWrapper = styled.div`
	margin-bottom: 5rem;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${media.mobileOnly`
		flex-direction: column;

		button {
			width: 100%;

			&:first-child {
				margin-bottom: 1.5rem;
			}
		}
	`};
`;

export const WarningBoxWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.gray};
	padding: 1.5rem 0;
	p {
		color: white;
		padding-left: 1rem;
		padding-right: 3rem;
		margin: 0;
		font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	}
`;

export const InnerContent = styled.div`
	${media.mobileOnly`
		text-align: center;
	`}

	${media.tablet`
		display: flex;
		align-items: center;
		justify-content: space-between;
	`}
`;

export const Item = styled.div`
	display: flex;
`;

export const Items = styled.div`
	${media.mobileOnly`
		padding: 0 3rem;
	`}
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const InfoWrapper = styled.div`
	margin: 0 0 2rem;
	font-size: 1.4rem;
`;

export const UsaSenderInformationEmphasis = styled.span`
	color: ${({ theme }) => theme.colors.primary};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const LithiumWarning = styled.div`
	margin: 0 0 2rem;
	color: red;
`;

export const CustomsInformationWrapper = styled.div`
	margin-top: 1.5rem;
`;
